import { removeDataPrefix } from '../hooks/useConvertFileToBuffer';

export const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      if (typeof reader.result !== 'string') {
        reject(new Error('FileReader result is not a string.'));
        return;
      }

      const base64String = removeDataPrefix(reader.result);
      resolve(base64String);
    };

    reader.onerror = () => {
      reject(new Error('Error reading file.'));
    };

    reader.readAsDataURL(file);
  });
};
